<div class="release-notes">
    <div class="top-navigation">
        <button class="nav-tab" [class.active]="selectedFilter === 'atualizacao'" (click)="setFilter('atualizacao')">
            {{ 'dashboard.releaseNotes.updates' | transloco }}
        </button>
        <button class="nav-tab" [class.active]="selectedFilter === 'aviso'" (click)="setFilter('aviso')">
            {{ 'dashboard.releaseNotes.notices' | transloco }}
        </button>
        <button class="nav-tab" [class.active]="selectedFilter === 'alerta'" (click)="setFilter('alerta')">
            {{ 'dashboard.releaseNotes.alerts' | transloco }}
        </button>
    </div>

    <div class="content-wrapper">
        <div class="main-content">
            @if (isLoading) {
                <div class="loading-message">{{ 'dashboard.releaseNotes.loading' | transloco }}</div>
            } @else if (filteredNotes.length === 0) {
                <div class="empty-state">
                    <mat-icon>info</mat-icon>
                    <h4>{{ 'dashboard.releaseNotes.emptyTitle' | transloco }}</h4>
                    <p>{{ 'dashboard.releaseNotes.emptyDescription' | transloco }}</p>
                </div>
            } @else {
                <div class="notes-list">
                    @for (note of filteredNotes; track note.id) {
                        <div class="note-card">
                            <div class="card-header">
                                <h3 class="note-title">{{ note.titulo }}</h3>
                                <span
                                    class="note-type"
                                    [style.color]="getTipoColor(note.tipo)"
                                    [style.background-color]="getTipoBackgroundColor(note.tipo)"
                                >
                                    {{ getTipoLabelKey(note.tipo) | transloco }}
                                </span>
                            </div>

                            <div class="note-description">{{ note.descricao }}</div>

                            <div
                                class="note-content w-100"
                                [innerHTML]="sanitizeHtml(note.conteudo)"
                                (click)="handleContentClick($event)"
                            ></div>

                            @if (note.video) {
                                <div class="w-100 d-none d-md-flex flex-column" [innerHTML]="note.video"></div>
                            }

                            <div class="note-footer">
                                <div class="responsavel-info">
                                    <div class="responsavel-avatar">{{ getInitials(note.responsavel) }}</div>
                                    <span class="responsavel-name">{{ note.responsavel | urlCurta: 40 }}</span>
                                </div>
                                <span class="note-date">{{ note.created_at | date: 'dd-MM-yyyy' }}</span>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    </div>

    <div class="release-notes__see-all">
        <a mat-stroked-button routerLink="/v2/release-notes" class="release-notes__see-all-btn" (click)="closePanel()">
            {{ 'dashboard.releaseNotes.seeAll' | transloco }}
        </a>
    </div>
</div>
